import AxiosInstance from "../config/axiosInterceptor";
import { ContentApiRoutes } from "../../navigation/NavConstant";

export const StoreServices = {
  getStores: (params?: any) => {
    return AxiosInstance.get(ContentApiRoutes.STORES, { params });
  },
  getRegions: (params?: any) => {
    return AxiosInstance.get(ContentApiRoutes.REGIONS, { params });
  },
  getStoreGroups: (params?: any) => {
    return AxiosInstance.get(ContentApiRoutes.STORE_GROUPS, { params });
  },
  viewStore: (id: number) => {
    return AxiosInstance.get(
      ContentApiRoutes.VIEW_STORE.replace(":id", id.toString())
    );
  },
};
